module.exports = __webpack_public_path__ + "img/low-create-comp.3bd1a55b.png";